import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddAnnotationsModalPage } from './add-annotations-modal.page';

const routes: Routes = [
  {
    path: 'annotate',
    component: AddAnnotationsModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddAnnotationsModalPage]
})
export class AddAnnotationsModalPageModule {}
